module.exports = __webpack_public_path__ + "static/media/cross_viejo.e4a2ac12.svg";